module.exports = __webpack_public_path__ + "fonts/CeraPro-Black.c212710.eot";